import { Container, Divider } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  ColorPickerInput,
  FormCard,
  FormLabel,
  FormUploadImage,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

function Personalisasi() {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [publisherLogo, setPublisherLogo] = useState({
    image_url: null,
    image: null,
  });
  const [payload, setPayload] = useState({
    name: "",
    email: "",
    phone: "",
    subdomain: "",
    address: "",
    theme_color: "#000000",
    profile_image: "",
  });
  const { theme_color, profile_image } = payload;

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/publisher/profile`, {
        headers,
      });
      const { data } = res?.data;
      const requiredKeys = [
        "address",
        "email",
        "name",
        "phone",
        "publisher_id",
        "subdomain",
        "theme_color",
        "profile_image",
      ];
      const filteredData = requiredKeys?.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      setPayload(filteredData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const modifiedPayload = {
      ...payload,
      ...(publisherLogo?.image && { image_logo: publisherLogo.image }),
    };
    const formData = new FormData();
    Object.keys(modifiedPayload).forEach(key => {
      if (key !== "profile_image" && key !== "publisher_id") {
        formData.append(key, modifiedPayload[key]);
      }
    });
    try {
      setSubmitting(true);
      await axios.put(`${hardBaseUrl}/publisher/profile`, formData, {
        headers,
      });
      ModalSuccess("Succesfully update Publisher Profile").then(() => {
        setPublisherLogo({
          image_url: null,
          image: null,
        });
        getDetail();
        window?.location?.reload();
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <Page className={classes?.root} title="Personalization">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Box marginBottom="20px">
          <Divider />
        </Box>
        {loadingPage ? (
          <SkeletonComponent variant="wave" />
        ) : (
          <Grid container columnSpacing={2} rowSpacing={1} mt="16px">
            <Grid item xs={12} md={6}>
              <SectionLabel
                title="Publisher Profile"
                subTitle="Customize publisher profile and URL to share"
              />
              <FormCard>
                <Grid container columnSpacing={2} rowSpacing={1}>
                  {MockFieldForm.map(
                    ({
                      key,
                      title,
                      disabled,
                      endAdorment,
                      fullRow,
                      multiline,
                      rows,
                      inputStyle,
                    }) => (
                      <Grid item xs={12} md={fullRow ? 12 : 6} key={key}>
                        <FormLabel label={title} required />
                        <TextInput
                          placeholder={title}
                          value={payload?.[key]}
                          endAdornment={endAdorment}
                          onChange={e =>
                            handleChangePayload(e?.target?.value, key)
                          }
                          multiline={multiline}
                          rows={rows}
                          disabled={disabled || submitting}
                          inputStyle={inputStyle}
                        />
                      </Grid>
                    )
                  )}
                </Grid>
              </FormCard>
            </Grid>
            <Grid item xs={12} md={6}>
              <SectionLabel
                title="Appearance"
                subTitle="Choose your company logo and customize the color theme"
              />
              <FormCard>
                <FormUploadImage
                  imageUrl={publisherLogo.image_url || profile_image}
                  setImageLogo={setPublisherLogo}
                />
                <Box mt="16px">
                  <FormLabel label="Theme Color" />
                  <ColorPickerInput
                    value={theme_color}
                    onChange={color =>
                      handleChangePayload(color, "theme_color")
                    }
                    disabled={submitting}
                  />
                </Box>
              </FormCard>
            </Grid>
          </Grid>
        )}
        <Divider className={classes?.divider} />
        <Grid container justifyContent="right">
          <PrimaryButton
            label={`${submitting ? "Saving" : "Apply"} Changes`}
            disabled={submitting}
            loading={submitting}
            onClick={handleSubmit}
          />
        </Grid>
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/personalisasi",
  },
  {
    label: "Personalization",
    active: true,
  },
];
const MockFieldForm = [
  {
    title: "Publisher Name",
    key: "name",
  },
  {
    title: "Publisher ID",
    key: "publisher_id",
    disabled: true,
  },
  {
    title: "Email",
    key: "email",
  },
  {
    title: "Phone Number",
    key: "phone",
  },
  {
    title: "Sub-Domain",
    key: "subdomain",
    endAdorment: ".caris.id",
    fullRow: true,
    inputStyle: { textAlign: "right" },
  },
  {
    title: "Address",
    key: "address",
    fullRow: true,
    multiline: true,
    rows: 4,
  },
];
export default Personalisasi;
